import { Col, Modal, Row, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "../../../../assets/style/modalStyle/addAccount.scss";

import {
  selectRouterAdmin,
  selectRouterClient,
} from "../../../../utils/ValueSelect";
import { validateUrl } from "../../../../utils/functionCommon";
import { useTranslation } from "react-i18next";
import { configMenuSelector } from "../../../../services/selector/index.";
import {
  addTabMenu,
  setOpenAddTab,
} from "../../../../services/slice/ConfigMenuSlice";
import TranslateText from "../../TranslateText";
import BaseButton from "../../Button/BaseButton";
import LabelInput from "../../LabelInput";
import InputText from "../../Input/InputText";
import SelectValue from "../../Selector/SelectValue";
import UploadIcon from "../../Button/UploadIcon";

const ModalAddTabMenu = ({ type }) => {
  const configMenuState = useSelector(configMenuSelector);
  const { t } = useTranslation();
  const language = localStorage.getItem("language");
  const valueSelect = useMemo(() => {
    const result = [];
    if (configMenuState.dataDisplay) {
      configMenuState.dataDisplay.map((item) => {
        if (item.router === "iframe") {
          result.push({
            value: item.router,
            label:
              language === "Tiếng Việt" ? (
                <Tooltip
                  title={
                    "Cho phép hiển thị một trang web khác bên trong website mà không cần mở thêm tab mới."
                  }
                >
                  {item.componentVn}
                </Tooltip>
              ) : (
                item.componentEn
              ),
          });
        } else {
          result.push({
            value: item.router,
            label:
              language === "Tiếng Việt" ? item.componentVn : item.componentEn,
          });
        }
      });
    }
    return result;
  }, [configMenuState.dataDisplay, language]);
  const [dataAdd, setDataAdd] = useState({
    file: "",
    nameVn: "",
    nameEn: "",
    router: "",
    url: "",
    typeUrl: "",
    type: type,
  });
  const dispatch = useDispatch();
  const handleCancel = () => {
    dispatch(setOpenAddTab(false));
  };
  const [msgErr, setMsgErr] = useState("");
  useEffect(() => {
    if (configMenuState.isError) {
      setMsgErr(configMenuState.msg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configMenuState.msg]);
  const handleSave = () => {
    const allowedFormats = ["image/svg+xml"];
    if (
      !dataAdd.file ||
      !dataAdd.nameVn ||
      !dataAdd.nameEn ||
      !dataAdd.router ||
      !dataAdd.typeUrl ||
      (dataAdd.typeUrl !== "local" && !dataAdd.url)
    ) {
      setMsgErr("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    if (dataAdd.typeUrl !== "local" && !validateUrl(dataAdd.url)) {
      setMsgErr("Đường dẫn không đúng định dạng");
      return;
    }
    if (dataAdd.file && !allowedFormats.includes(dataAdd.file.type)) {
      setMsgErr("Icon không đúng định dạng");
      return;
    }
    const formPost = new FormData();
    formPost.append("file", dataAdd.file);
    formPost.append("type", dataAdd.type);
    formPost.append("nameVn", dataAdd.nameVn);
    formPost.append("nameEn", dataAdd.nameEn);
    formPost.append("router", dataAdd.router);
    formPost.append("typeUrl", dataAdd.typeUrl);
    formPost.append("url", dataAdd.url);
    dispatch(addTabMenu(formPost));
    setMsgErr("");
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text={"Thêm Tab"} />}
        centered
        open={configMenuState.isOpenAddTab}
        className="warrperModalAddAcc"
        width={645}
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              isEnter={true}
              width={155}
              content={"Lưu"}
              typeBtn="btnOrange"
              handleClick={handleSave}
            />
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Row align={"middle"} style={{ marginBottom: "1.5rem" }}>
          <Col span={7}>
            <LabelInput text={"Tên tiếng Việt của Tab"} />
          </Col>
          <Col span={17}>
            <InputText
              focus
              setText={(value) => setDataAdd({ ...dataAdd, nameVn: value })}
              placeholder={"Nhập tên tab"}
              typeInput={`${
                (!dataAdd.nameVn && msgErr) ||
                msgErr === "Duplicate menu tab name"
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row align={"middle"} style={{ marginBottom: "1.5rem" }}>
          <Col span={7}>
            <LabelInput text={"Tên tiếng Anh của Tab"} />
          </Col>
          <Col span={17}>
            <InputText
              setText={(value) => setDataAdd({ ...dataAdd, nameEn: value })}
              typeInput={`${
                !dataAdd.nameEn && msgErr
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
              placeholder={"Nhập tên Tiếng Anh của tab"}
            />
          </Col>
        </Row>
        <Row align={"middle"} style={{ marginBottom: "1.5rem" }}>
          <Col span={7}>
            <LabelInput text={"Giao diện hiển thị"} />
          </Col>
          <Col
            span={17}
            style={
              !dataAdd.typeUrl && msgErr
                ? {
                    border: "1px solid red",
                    width: "100%",
                    textAlign: "left",
                  }
                : { width: "100%", textAlign: "left" }
            }
          >
            <SelectValue
              width={"100%"}
              handleChange={(value) => {
                setDataAdd({
                  ...dataAdd,
                  typeUrl: value,
                });
              }}
              optionsValue={valueSelect ? valueSelect : []}
              type={"base"}
              defaultValue="Chọn"
            />
          </Col>
        </Row>

        <Row
          align={"middle"}
          style={{ position: "relative", marginBottom: "1.5rem" }}
        >
          <Col span={7}>
            <LabelInput text={"Điều hướng đến"} />
          </Col>
          <Col
            span={17}
            style={
              !dataAdd.router && msgErr
                ? {
                    border: "1px solid red",
                    width: "100%",
                    textAlign: "left",
                  }
                : { width: "100%", textAlign: "left" }
            }
          >
            <SelectValue
              handleChange={(value) => {
                setDataAdd({
                  ...dataAdd,
                  router: value,
                });
              }}
              optionsValue={type ? selectRouterAdmin : selectRouterClient}
              type={"base"}
              width={"100%"}
              defaultValue={"Chọn"}
            />
          </Col>
        </Row>
        {dataAdd.typeUrl !== "local" && dataAdd.typeUrl ? (
          <Row
            align={"middle"}
            style={{ position: "relative", marginBottom: "1.5rem" }}
          >
            <Col span={7}>
              <LabelInput text={"Nhập link"} />
            </Col>
            <Col
              span={17}
              style={
                (!dataAdd.url && msgErr) ||
                msgErr === "Đường dẫn không đúng định dạng"
                  ? {
                      border: "1px solid red",
                      width: "100%",
                      textAlign: "left",
                    }
                  : { width: "100%", textAlign: "left" }
              }
            >
              <InputText
                setText={(value) => setDataAdd({ ...dataAdd, url: value })}
                typeInput={"baseInput"}
                placeholder={"Nhập link"}
              />
            </Col>
          </Row>
        ) : null}

        <Row
          align={"middle"}
          style={{ position: "relative", marginBottom: "1.5rem" }}
        >
          <Col span={7}>
            <LabelInput text={"Chọn icon"} />
          </Col>
          <Col
            span={3}
            style={{ display: "flex", justifyContent: "start", width: "100%" }}
          >
            <UploadIcon
              width={"100%"}
              style={
                !dataAdd.file && msgErr ? { border: "1px solid red" } : null
              }
              setImage={(file) => setDataAdd({ ...dataAdd, file: file })}
            />
          </Col>
          <Col span={7}>
            <span
              style={{
                fontStyle: "italic",
                fontSize: "1.4rem",
                color: "#4F4F4F",
              }}
            >
              (<TranslateText text={"file có định dạng .svg"} />)
            </span>
          </Col>
          <small className="msg" style={{ bottom: -30, left: 20 }}>
            {t(msgErr)}
          </small>
        </Row>
      </Modal>
    </>
  );
};

export default ModalAddTabMenu;
